import React, {
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  useMemo,
} from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  Collapse,
  Divider,
  CircularProgress,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import { useNavigate, Outlet, useParams, useLocation } from "react-router-dom";
import jsonData from "./mainpageconfig.json";
// import SearchSharpIcon from "@mui/icons-material/SearchSharp";
// import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import InputBase from "@mui/material/InputBase";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CircleProgressBar from "../progress/CircleProgressBar";
import { LinearProgress } from "@mui/material";
import ApiMap from "../../utils/ApiMap";
import AuthService from "../../utils/AuthService";
import axios from "axios";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import QuizIcon from "@mui/icons-material/Quiz";
import Tooltip from "@mui/material/Tooltip";
import { Avatar } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import CourseServices from "../../apis/CourseServices";
import BookmarksIcon from "@mui/icons-material/Bookmarks";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import LessonAuthoringService from "../../apis/LessonAuthoringService";
import CourseSearchInput from "./CourseSearchInput";

const MainPage = ({ setShowAppBar }) => {
  console.log("Mainpage");
  const [isShrunk, setIsShrunk] = useState(false);
  const [showMainContent, setShowMainContent] = useState(true);
  //const [isRoutedPageVisible, setIsRoutedPageVisible] = useState(false);
  const [isFirstRender, setIsFirstRender] = useState(true);
  //const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [expandedLinkIndex, setExpandedLinkIndex] = useState([]);
  const detailsSectionRef = useRef(null);
  const navigate = useNavigate();
  const [isSidebarHidden, setIsSidebarHidden] = useState(false);
  //const [shouldAutoHideSidebar, setShouldAutoHideSidebar] = useState(false);
  const [lessonProgress, setLessonProgress] = useState({});
  //const [validLessonIds, setValidLessonIds] = useState([]);
  const [moduleList, setModuleList] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  let { courseId } = useParams();
  const [crsId] = useState(courseId);
  //const [lessonList, setLessonList] = useState(null);
  const [moduleLessons, setModuleLessons] = useState({});
  const [loadingModules, setLoadingModules] = useState({});
  const location = useLocation();
  const [activeModuleId, setActiveModuleId] = useState(null);
  const [details, setDetails] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [userGrades, setUserGrades] = useState([]);
  const [courseName, setCourseName] = useState("");
  const lessonRefs = useRef({});
  //const [highlightedLesson, setHighlightedLesson] = useState(null);
  const [bookmarkedLessons, setBookmarkedLessons] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [highlightIndex, setHighlightIndex] = useState(-1);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [facultyGrading, setFacultyGrading] = useState({});
  const [showExitModal, setShowExitModal] = useState(false);
  const [pendingLessonNavigation, setPendingLessonNavigation] = useState(null);
  const [quizSubmissions, setQuizSubmissions] = useState({});
  const [manualSidebarToggle, setManualSidebarToggle] = useState(false);
  const [isSearchSubmitted, setIsSearchSubmitted] = useState(false);
  const hasScrolledFromURL = useRef(false);
  const sidebarWidth = useMemo(() => {
    const isLessonUrl = location.pathname.includes("/Lesson/");
    const isSearchPage = location.pathname.includes("/searchresultspage");
    if (isSidebarHidden) return "0px";

    if (window.innerWidth <= 768 && isSearchPage) return "0px";

    if (window.innerWidth <= 768) {
      // On mobile, if not on lesson page and not hidden, show full width
      return isLessonUrl
        ? jsonData.columns[0]?.content.mobileWidth
        : jsonData.columns[0]?.content.unshrinkWidth;
    }

    return isShrunk
      ? jsonData.columns[0]?.content.shrinkWidth
      : jsonData.columns[0]?.content.unshrinkWidth;
  }, [isSidebarHidden, isShrunk, location.pathname]);

  useLayoutEffect(() => {
    setShowAppBar(false);
    return () => {
      setShowAppBar(true);
    };
  }, [setShowAppBar]);

  useEffect(() => {
    const storedCourseName = localStorage.getItem("courseName");
    if (storedCourseName) {
      setCourseName(storedCourseName);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      // 👇 Skip auto logic if user manually toggled the sidebar
      if (manualSidebarToggle) return;

      const isLessonUrl = location.pathname.includes("/Lesson/");
      if (window.innerWidth <= 768) {
        setIsSidebarHidden(isLessonUrl); // hide only on lesson page
      } else {
        setIsSidebarHidden(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [location.pathname, manualSidebarToggle]);

  useEffect(() => {
    return () => {
      // cleanup when leaving this page
      localStorage.removeItem("quizUnsaved");
    };
  });

  useEffect(() => {
    if (!isFirstRender) {
      setShowMainContent(false);
      const timeout = setTimeout(() => {
        setShowMainContent(true);
      }, 700);
      return () => clearTimeout(timeout);
    }
  }, [isShrunk, isFirstRender]);

  useEffect(() => {
    setIsFirstRender(false);
  }, []);

  useEffect(() => {
    if (location.pathname === `/Modules/Course/${courseId}`) {
      setIsShrunk(false); // Expands sidebar when back to course page
    } else {
      setIsShrunk(true); // Shrinks sidebar when moving forward to lesson
    }
  }, [location.pathname, courseId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true); // Set loading to true before fetching
        const resp = await axios(
          `${ApiMap.COURSE_MODULES}/course/${courseId}/modules`,
          AuthService.getAuthHeader()
        );
        let modList = resp.data;
        modList.sort((a, b) => a.id - b.id);
        setModuleList(modList);
      } catch (error) {
        console.error("Error fetching modules:", error);
      } finally {
        setIsLoading(false); // Ensure loading is false after fetch
      }
    };

    if (AuthService.isLoggedIn()) {
      fetchData();
    }
  }, [courseId]); // Depend on crsId

  useEffect(() => {
    const isLessonUrl = location.pathname.includes("/Lesson/");
    if (isLessonUrl) {
      //setIsRoutedPageVisible(true);
      setIsShrunk(true);
      if (window.innerWidth <= 768) {
        setIsSidebarHidden(true);
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    if (isSearchSubmitted) return;
    if (!searchQuery.trim() || searchQuery.length <= 2) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }
    let cancelled = false;
    const fetchSuggestions = async () => {
      try {
        const resp = await LessonAuthoringService.searchCourseContent(
          courseId,
          searchQuery
        );

        if (cancelled) return;

        const items = resp?.items || [];
        setSuggestions(items.slice(0, 5));
        setShowSuggestions(items.length > 0);
      } catch (err) {
        console.error("Suggestion search failed", err);
      }
    };
    fetchSuggestions();
    return () => {
      cancelled = true;
    };
  }, [searchQuery, isSearchSubmitted]);

  const handleToggleLessons = async (index, moduleId) => {
    setActiveModuleId(moduleId);
    setExpandedLinkIndex((prevIndices) =>
      prevIndices.includes(index)
        ? prevIndices.filter((i) => i !== index)
        : [...prevIndices, index]
    );

    if (!moduleLessons[moduleId]) {
      setLoadingModules((prev) => ({ ...prev, [moduleId]: true }));

      try {
        const resp = await axios.get(
          `${ApiMap.MODULES_LESSONS}/course/${crsId}/module/${moduleId}/lessons`,
          AuthService.getAuthHeader()
        );

        const lsnList = resp.data.sort((a, b) => a.seq - b.seq);

        setModuleLessons((prevLessons) => ({
          ...prevLessons,
          [moduleId]: lsnList,
        }));

        // 🔥 Fetch grades
        const gradesData = await fetchGradesForLessons(
          lsnList,
          courseId,
          moduleId
        );

        setUserGrades((prevGrades) => [
          ...prevGrades,
          ...Object.entries(gradesData).map(([lessonId, gradeObj]) => ({
            lessonId,
            moduleId,
            gradeObtained: gradeObj?.gradeObtained ?? null,
            gradedAllowed: gradeObj?.gradeAllowed ?? null,
            dateCompleted: gradeObj?.dateSubmitted ?? null,
            graded: gradeObj?.graded ?? null,
            completed: gradeObj?.completed ?? null,
          })),
        ]);

        // ✅ Fetch for all unique chapterIds
        const uniqueChapterIds = [
          ...new Set(lsnList.map((l) => l.chapterId).filter(Boolean)),
        ];

        for (const chapterId of uniqueChapterIds) {
          // Fetch bookmarks (existing functionality)
          await fetchBookmarksForModule(moduleId, chapterId);

          // 🔥 Fetch faculty grading status if user is faculty
          if (AuthService.isFaculty(courseId)) {
            const { gradingStats, quizSubmissions } =
              await fetchFacultyGradingStatus(courseId, moduleId, chapterId);

            // update faculty grading stats
            setFacultyGrading((prev) => ({
              ...prev,
              [moduleId]: {
                ...(prev[moduleId] || {}),
                ...gradingStats,
              },
            }));

            // 🔥 store quiz submissions
            setQuizSubmissions((prev) => ({
              ...prev,
              [moduleId]: {
                ...(prev[moduleId] || {}),
                ...quizSubmissions, // lessonId → submissions[]
              },
            }));
          }
        }
      } catch (error) {
        console.error("Error fetching lessons:", error);
      } finally {
        setLoadingModules((prev) => ({ ...prev, [moduleId]: false }));
      }
    }
  };

  const fetchGradesForLessons = async (lessons, courseId, moduleId) => {
    const authToken = AuthService.getAuthHeader();
    const token = authToken.headers?.Authorization;
    if (!token) {
      console.error("Authorization token is missing");
      return {};
    }
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");
    if (lessons.length === 0) return {};
    const raw = JSON.stringify({
      Name: "MyAssignmentSubmissions",
      Key: `user#{{myid}}`,
      SKey: {
        value: `submission;crs#${courseId};mod#${moduleId};chp#${1};`,
        optype: "begins",
      },
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `https://dev.marvelapi.com/app/v1/getitems`,
        requestOptions
      );
      const result = await response.json();
      const allSubmissions = result || []; // in case result.items is the array
      const gradesData = {};
      lessons.forEach((lesson) => {
        const match = allSubmissions.find((item) =>
          item.SK.includes(`id#${lesson.id}`)
        );
        gradesData[lesson.id] = match || null; // If not found, store null
      });
      return gradesData;
    } catch (error) {
      console.error("Error fetching grades:", error);
      return {};
    }
  };

  const fetchBookmarksForModule = async (moduleId, chapterId) => {
    try {
      const resp = await CourseServices.getBookmarks(
        courseId,
        moduleId,
        chapterId
      );
      if (resp.status === 200 && Array.isArray(resp.data)) {
        const lessons = resp.data.map((item) => {
          const skParts = item.SK.split(";");
          const extractId = (key) =>
            parseInt(skParts.find((p) => p.startsWith(key))?.split("#")[1]);

          return {
            courseId: extractId("crs"),
            moduleId: extractId("mod"),
            chapterId: extractId("chp"),
            lessonId: extractId("id"),
            bookmarkedOn: item.bookmarkedOn,
            notes: item.notes || "",
          };
        });

        // Append or merge with existing bookmarks
        setBookmarkedLessons((prev) => {
          const newLessonIds = new Set(lessons.map((l) => l.lessonId));
          const filteredPrev = prev.filter(
            (l) => !newLessonIds.has(l.lessonId)
          );
          return [...filteredPrev, ...lessons];
        });
      }
    } catch (err) {
      console.error("Failed to fetch bookmarks", err);
    }
  };
  const fetchFacultyGradingStatus = async (courseId, moduleId, chapterId) => {
    const requestBody = {
      Name: "StudentSubmissions",
      IndexName: "index2",
      Key: "grades",
      SKey: {
        value: `crs#${courseId};mod#${moduleId};chp#${chapterId}`,
        optype: "begins",
      },
    };

    try {
      const response = await axios.post(
        "https://dev.marvelapi.com/app/v1/getitems",
        requestBody,
        AuthService.getAuthHeader()
      );

      const data = response.data;
      const gradingStats = {};
      const quizSubmissions = {}; // 🔥 store per lessonId

      for (const item of data) {
        const lessonId = item.SK?.split("id#")[1];
        if (!lessonId) continue;

        const isGraded = item.graded === true && !!item.gradedDate;
        const isPending = item.graded === false;

        const normalizedLessonId = String(lessonId);

        // build grading stats
        if (!gradingStats[normalizedLessonId]) {
          gradingStats[normalizedLessonId] = {
            gradedCount: 0,
            pendingCount: 0,
          };
        }
        if (isGraded) gradingStats[normalizedLessonId].gradedCount += 1;
        else if (isPending) gradingStats[normalizedLessonId].pendingCount += 1;

        // 🔥 collect quiz submissions
        if (
          item.gradeObtained !== undefined &&
          item.gradeAllowed !== undefined
        ) {
          if (!quizSubmissions[normalizedLessonId]) {
            quizSubmissions[normalizedLessonId] = [];
          }

          // Extract userId from PK
          const userId = item.PK?.split("user#")[1] || null;

          // Extract chapterId & lessonId from GSK1
          const chapterIdMatch = item.GSK1?.match(/chp#(\d+)/);
          const lessonIdMatch = item.GSK1?.match(/id#(\d+)/);

          const chapterId = chapterIdMatch ? chapterIdMatch[1] : null;
          const lessonId = lessonIdMatch ? lessonIdMatch[1] : null;

          quizSubmissions[normalizedLessonId].push({
            userId,
            chapterId,
            lessonId,
            gradeObtained: item.gradeObtained,
            gradeAllowed: item.gradeAllowed,
            dateSubmitted: item.dataSubmitted || item.dateSubmitted,
            submitCount: item.submitcount,
          });
        }
      }

      return { gradingStats, quizSubmissions };
    } catch (error) {
      console.error("Error fetching faculty grading data:", error);
      return { gradingStats: {}, quizSubmissions: {} };
    }
  };

  useEffect(() => {
    hasScrolledFromURL.current = false; // 👈 Reset scroll flag on route change
  }, [location.pathname]);

  useEffect(() => {
    if (hasScrolledFromURL.current || !moduleList || moduleList.length === 0)
      return;

    const pathParts = location.pathname.split("/");

    const moduleIndex = pathParts.findIndex((part) => part === "Module");
    const lessonIndex = pathParts.findIndex((part) => part === "Lesson");

    if (moduleIndex !== -1 && lessonIndex !== -1) {
      const moduleId = parseInt(pathParts[moduleIndex + 1]);
      const lessonId = parseInt(pathParts[lessonIndex + 1]);

      const moduleIndexInList = moduleList.findIndex((m) => m.id === moduleId);

      const scrollToLesson = () => {
        const ref = lessonRefs.current?.[moduleId]?.[lessonId];
        if (ref?.scrollIntoView) {
          ref.scrollIntoView({ behavior: "smooth", block: "center" });
          hasScrolledFromURL.current = true;
          //setHighlightedLesson({ moduleId, lessonId });
        }
      };

      const expandAndScroll = async () => {
        if (
          !expandedLinkIndex.includes(moduleIndexInList) &&
          moduleIndexInList !== -1
        ) {
          await handleToggleLessons(moduleIndexInList, moduleId);
          setTimeout(scrollToLesson, 300); // Wait after DOM expands
        } else {
          setTimeout(scrollToLesson, 100); // If already expanded
        }
      };

      expandAndScroll();
    }
  }, [location.pathname, moduleList, expandedLinkIndex]);

  const toggleBookmark = async (moduleId, lessonId, chapterId) => {
    try {
      const isBookmarked = bookmarkedLessons.some(
        (item) => item.moduleId === moduleId && item.lessonId === lessonId
      );

      let response;
      if (isBookmarked) {
        response = await CourseServices.unBookMarkLesson(
          courseId,
          moduleId,
          chapterId,
          lessonId
        );
      } else {
        response = await CourseServices.bookMarkLesson(
          courseId,
          moduleId,
          chapterId,
          lessonId
        );
      }

      if (response?.status === 200) {
        setBookmarkedLessons((prev) => {
          if (isBookmarked) {
            return prev.filter(
              (item) =>
                !(item.moduleId === moduleId && item.lessonId === lessonId)
            );
          } else {
            return [...prev, { courseId, moduleId, chapterId, lessonId }];
          }
        });
      }
    } catch (error) {
      console.error("Bookmark toggle failed", error);
    }
  };

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  const handleProgressClick = async (
    lessonId,
    moduleId,
    chapterId,
    dateCompleted
  ) => {
    if (!AuthService.isFaculty(courseId)) {
      return; // Students cannot toggle progress
    }

    const progress = lessonProgress[moduleId]?.[lessonId];

    const isCompleted =
      progress !== undefined ? progress === 100 : !!dateCompleted;

    if (isCompleted) {
      const resp = await CourseServices.markLessonInComplete(
        courseId,
        moduleId,
        chapterId,
        lessonId
      );
      if (resp.status === 200) {
        setLessonProgress((prev) => ({
          ...prev,
          [moduleId]: {
            ...(prev[moduleId] || {}),
            [lessonId]: 0,
          },
        }));
      }
    } else {
      const resp = await CourseServices.markLessonComplete(
        courseId,
        moduleId,
        chapterId,
        lessonId
      );
      if (resp.status === 200) {
        setLessonProgress((prev) => ({
          ...prev,
          [moduleId]: {
            ...(prev[moduleId] || {}),
            [lessonId]: 100,
          },
        }));
      }
    }
  };

  // const handleInActiveLessons = (inactiveIds) => {
  //   //const inValidIdsAsIntegers = inactiveIds.map((id) => parseInt(id, 10));
  //   //setValidLessonIds(inValidIdsAsIntegers); // Update state with valid lesson IDs
  // };

  const handleStartCourse = () => {
    //setShouldAutoHideSidebar(true);
    const lessonsData = null; // Assuming lessons are stored here
    setIsShrunk(true);
    setTimeout(() => {
      //setIsRoutedPageVisible(true);
      navigate(
        `/Modules/Course/${courseId}/Module/${1}/Chapter/${1}/Lesson/${5}`,
        {
          state: {
            lessons: lessonsData,
          },
        }
      ); // Pass lessons as state
    }, 700);
  };

  const handleViewDetails = () => {
    if (!moduleList) return; // Avoid errors if moduleList is null
    const overView =
      "This is the foundational level where you learn the crucial 20% of the language needed to comprehend 80% of the Quran and Arabic. You'll master 8 key sounds and basic sounds of Arabic, using a distinctive approach to language learning.";
    const totalModules = moduleList.length;
    const totalDuration = moduleList.reduce(
      (acc, module) => acc + (module.duration || 0),
      0
    );
    const hours = Math.floor(totalDuration / 60);
    const minutes = totalDuration % 60;
    const formattedDuration = `${hours} hr ${minutes} min`;
    setDetails({ totalModules, totalDuration, formattedDuration, overView }); // Store in state
    setExpanded(!expanded); // Toggle expand state
  };

  const handleExit = () => {
    setIsShrunk(false);
    //setIsRoutedPageVisible(false);
    setIsSidebarHidden(false);
    navigate("/coursepage");
  };

  const handleGoHome = () => {
    navigate("/");
  };

  const handleExitCourse = () => {
    const assignmentUnsaved = localStorage.getItem("assignmentUnsaved");
    const quizUnsaved = localStorage.getItem("quizUnsaved");

    if (assignmentUnsaved === "true" || quizUnsaved === "true") {
      // Show modal first if either page has unsaved changes
      setShowExitModal(true);
    } else {
      // Direct navigation
      setIsShrunk(false);
      setIsSidebarHidden(false);
      setShowExitModal(false);
      navigate(`/Modules/Course/${courseId}`);
    }
  };

  const handleSearch = async (query) => {
    const trimmed = query.trim();
    if (!trimmed) return;
    // 🔒 lock suggestions FIRST
    setIsSearchSubmitted(true);

    // 🔥 reset UI state
    setSearchQuery("");
    setSuggestions([]);
    setShowSuggestions(false);
    setHighlightIndex(-1);

    setIsShrunk(true);
    if (window.innerWidth <= 768) setIsSidebarHidden(true);
    const resp = await LessonAuthoringService.searchCourseContent(
      courseId,
      trimmed
    );
    navigate("searchresultspage", {
      state: {
        results: resp.items || [],
        nextToken: resp.nextToken || null,
        query: trimmed,
        courseId,
      },
    });
  };

  const getFilteredLessons = (link) => {
    return moduleLessons[link.id] || [];
  };

  const handleStartCourseOnLesson = (lesson, moduleId) => {
    const assignmentUnsaved = localStorage.getItem("assignmentUnsaved");
    const quizUnsaved = localStorage.getItem("quizUnsaved");
    setActiveModuleId(moduleId);
    const allLessons = moduleLessons[moduleId] || [];
    const chapter = allLessons.find((item) => item.id === lesson.id);
    const chapterId = chapter ? chapter.chapterId : null;
    const contentId = chapter ? chapter.id : null;
    const destination = {
      pathname: `/Modules/Course/${courseId}/Module/${moduleId}/Chapter/${chapterId}/Lesson/${lesson.id}`,
      state: {
        lessons: allLessons,
        lessonName: lesson.name,
        contentId,
      },
    };

    if (assignmentUnsaved === "true" || quizUnsaved === "true") {
      setPendingLessonNavigation(destination);
      setShowExitModal(true);
      return;
    }

    navigateToLesson(destination, moduleId, chapterId, lesson.id);
  };

  const navigateToLesson = (destination, moduleId, chapterId, lessonId) => {
    setActiveModuleId(moduleId);

    if (window.innerWidth <= 768) setIsSidebarHidden(true);

    // Save last visited lesson
    localStorage.setItem(
      `lastVisitedMoudle_${courseId}`,
      JSON.stringify({
        moduleId,
        chapterId,
        lessonId,
      })
    );

    setIsShrunk(true);
    setTimeout(
      () => {
        navigate(destination.pathname, {
          replace: false,
          state: destination.state,
        });
      },
      isShrunk ? 0 : 700
    );
  };

  const calculateModuleProgress = () => {
    if (!moduleLessons || !activeModuleId || !moduleLessons[activeModuleId]) {
      return 0;
    }
    const lessons = moduleLessons[activeModuleId];

    if (!lessons || lessons.length === 0) {
      return 0;
    }
    const totalLessons = lessons.length;
    const completedLessons = lessons.filter(
      (lesson) => lessonProgress?.[lesson.id] === 100
    );
    const progress = (completedLessons.length / totalLessons) * 100;

    return progress;
  };

  const getModuleProgress = (moduleLessons, linkId) => {
    const filteredLessons = moduleLessons[linkId];
    if (!filteredLessons || filteredLessons.length === 0) return null;

    const completedLessons = filteredLessons.filter(
      (l) => l.dateCompleted
    ).length;
    const totalLessons = filteredLessons.length || 1;
    return Math.round((completedLessons / totalLessons) * 100);
  };

  return (
    <Grid
      container
      direction="column"
      sx={{
        minHeight: "100vh",
      }}
    >
      {!isShrunk && showMainContent ? (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            right: 0,
            zIndex: 1001,
            margin: "10px",
          }}
        >
          <Button
            onClick={handleExit}
            sx={{
              color: "black",
              textDecoration: "underline",
              textDecorationColor: "#424242",
            }}
          >
            My Courses
          </Button>
          <Button
            onClick={handleGoHome}
            sx={{
              color: "black",
              textDecoration: "underline",
              textDecorationColor: "#424242",
            }}
          >
            Home
          </Button>
        </Box>
      ) : (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            right: 0,
            zIndex: 1001,
          }}
        >
          <Button
            onClick={handleExitCourse}
            sx={{
              color: "black",
              textDecoration: "underline",
              textDecorationColor: "#424242",
            }}
          >
            Exit
          </Button>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          minHeight: "100vh",
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: sidebarWidth,
            transition: "width 0.5s ease, opacity 0.5s ease",
            overflowX: "auto",
            position: "fixed",
            left: 0,
            top: 0,
            zIndex: 1000,
            borderRight: "2px solid #e0e0e0",
            height: "100vh",
          }}
        >
          {/* Header Section */}
          <Grid
            item
            sx={{
              width: "100%",
              minHeight: isShrunk ? "45vh" : "55vh",
              bgcolor: "primary.main",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              transition: "height 0.7s ease-out",
              paddingLeft: isShrunk ? "5px" : "none",
              padding: 2,
            }}
          >
            {isShrunk && showMainContent && (
              <Box sx={{ position: "relative", width: "100%", maxWidth: 300 }}>
                <CourseSearchInput
                  key={isShrunk ? "shrunk-search" : "expanded-search"} // 🔥 FORCE REMOUNT
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                  suggestions={suggestions}
                  setSuggestions={setSuggestions}
                  showSuggestions={showSuggestions}
                  setShowSuggestions={setShowSuggestions}
                  highlightIndex={highlightIndex}
                  setHighlightIndex={setHighlightIndex}
                  onSearch={handleSearch}
                  isSearchSubmitted={isSearchSubmitted}
                  setIsSearchSubmitted={setIsSearchSubmitted}
                  isShrunk={isShrunk}
                  width="100%"
                />

                {showSuggestions && suggestions.length > 0 && (
                  <Box
                    sx={{
                      position: "absolute",
                      fontSize: "14px",
                      top: "35px",
                      left: 0,
                      width: "100%",
                      backgroundColor: "#fff",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      zIndex: 1000,
                      borderRadius: "8px",
                      maxHeight: "200px",
                      overflowY: "auto",
                    }}
                  >
                    {suggestions.map((item, index) => (
                      <Box
                        key={index}
                        onClick={() => {
                          setShowSuggestions(false); // close dropdown
                          setSuggestions([]);
                          handleSearch(item.name); // navigate
                          setSearchQuery(""); // clear input so dropdown won't reopen
                        }}
                        sx={{
                          padding: "8px 12px",
                          cursor: "pointer",
                          backgroundColor:
                            highlightIndex === index
                              ? "#f0f0f0"
                              : "transparent",
                          "&:hover": { backgroundColor: "#f0f0f0" },
                        }}
                      >
                        {item.name}
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            )}

            {showMainContent && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  width: "100%",
                  maxWidth: 500,
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      //fontSize: isShrunk ? "1.8rem" : "2rem",
                      fontFamily: "Lato, sans-serif",
                      transition: "font-size 0.7s ease-out",
                      marginBottom: "20px",
                      cursor: "pointer",
                      textAlign: isShrunk ? "center" : "left",
                      fontWeight: 900,
                      marginTop: "16px",
                      color: "#ffffff",
                    }}
                    onClick={handleExit}
                  >
                    {courseName || "Welcome to the Course"}
                  </Typography>
                </Box>
                {isShrunk && (
                  <Box
                    sx={{ width: "100%", marginTop: "16px", padding: "10px" }}
                  >
                    {/* Linear Progress Bar */}
                    <LinearProgress
                      variant="determinate"
                      value={calculateModuleProgress()}
                      sx={{
                        height: "2px",
                        borderRadius: "4px",
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "#ffffff", // Custom color for the progress bar
                        },
                      }}
                    />

                    {/* Percentage and Completed Message */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start", // Align to the left
                        margin: "4px", // Add some space below the progress bar
                      }}
                    >
                      <Typography variant="body2">
                        {`${Math.round(calculateModuleProgress())}% Completed`}
                      </Typography>
                    </Box>
                  </Box>
                )}

                {showMainContent && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: "100%",
                      maxWidth: 500,
                      gap: 2,
                    }}
                  >
                    {/* Buttons Section */}
                    <Box sx={{ display: "flex", gap: "16px", width: "100%" }}>
                      {/* When sidebar is expanded → show all buttons */}
                      {!isShrunk &&
                        jsonData.columns[0]?.content.buttons?.map(
                          (button, index) => (
                            <Button
                              key={index}
                              variant="contained"
                              color="white"
                              sx={{
                                borderRadius: "15px",
                                transition: "all 0.7s ease-out",
                              }}
                              onClick={() => {
                                if (button.action === "handleStartCourse") {
                                  handleStartCourse();
                                } else {
                                  handleViewDetails();
                                }
                              }}
                            >
                              {button.label}
                              {button.label === "View Course Details" ? (
                                expanded ? (
                                  <ExpandLessIcon />
                                ) : (
                                  <ExpandMoreIcon />
                                )
                              ) : null}
                            </Button>
                          )
                        )}

                      {/* 🔹 Always visible Join Game button (visible in both modes) */}
                      {AuthService.isStudent(courseId) && (
                        <Button
                          variant="contained"
                          color="secondary"
                          size={isShrunk ? "small" : "medium"}
                          sx={{
                            borderRadius: "15px",
                            width: isShrunk ? "100%" : "auto",
                            textTransform: "none",
                            boxShadow: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                          onClick={() => navigate("/Gameroom")}
                        >
                          <SportsEsportsIcon
                            sx={{
                              fontSize: isShrunk ? 18 : 22,
                              color: "white",
                              filter: "drop-shadow(0 0 2px rgba(0,0,0,0.3))",
                            }}
                          />
                          Join Game
                        </Button>
                      )}
                    </Box>

                    {/* 🔹 Search box and details only when expanded */}
                    {!isShrunk && (
                      <CourseSearchInput
                        key={isShrunk ? "shrunk-search" : "expanded-search"} // 🔥 FORCE REMOUNT
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                        suggestions={suggestions}
                        setSuggestions={setSuggestions}
                        showSuggestions={showSuggestions}
                        setShowSuggestions={setShowSuggestions}
                        highlightIndex={highlightIndex}
                        setHighlightIndex={setHighlightIndex}
                        onSearch={handleSearch}
                        isSearchSubmitted={isSearchSubmitted}
                        setIsSearchSubmitted={setIsSearchSubmitted}
                        isShrunk={isShrunk}
                        width="100%"
                      />
                    )}
                  </Box>
                )}

                <Collapse in={expanded} sx={{ marginTop: "10px" }}>
                  {details && !isShrunk && (
                    <Card
                      sx={{
                        borderRadius: "10px",
                        boxShadow: 2,
                        padding: "8px",
                        marginRight: 3,
                      }}
                    >
                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column", // Ensures content stacks vertically
                          alignItems: "flex-start", // Align content to the left
                          gap: 1, // Adds spacing between sections
                          padding: "2px 8px",
                        }}
                      >
                        {/* First row: Video Count, Total Modules, and Duration */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%", // Ensures it takes full width
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <IconButton>
                              <PlayCircleOutlineIcon />
                            </IconButton>
                            <Typography

                            //sx={{ color: "#455a64", fontSize: "0.75rem" }}
                            >
                              {details.videoCount} Videos
                            </Typography>
                          </Box>

                          <Typography
                            variant="body2"
                            sx={{
                              marginRight: 2,
                            }}
                          >
                            <strong>Total Modules:</strong>{" "}
                            {details.totalModules}
                          </Typography>

                          <Typography
                            variant="body2"
                            //sx={{ color: "#455a64", fontSize: "0.75rem" }}
                          >
                            <strong>Total Dur:</strong>{" "}
                            {details.formattedDuration}
                          </Typography>
                        </Box>

                        {/* Second row: Overview - This will appear below the first row */}
                        <Typography
                          variant="body2"
                          sx={{
                            marginTop: "8px", // Space between first row and overview
                            width: "100%", // Ensures it spans full width
                          }}
                        >
                          <strong>Overview:</strong> {details.overView}
                        </Typography>
                      </CardContent>
                    </Card>
                  )}
                </Collapse>
              </Box>
            )}
          </Grid>

          {/* Content Section */}
          {showMainContent && (
            <Grid
              item
              ref={detailsSectionRef}
              sx={{
                width: "100%",
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: isShrunk ? "flex-start" : "center",
                alignItems: isShrunk ? "flex-start" : "center",
                maxHeight: isShrunk ? "65vh" : "auto",
                padding: "8px",
                transition: "all 0.7s ease-out",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  width: "100%",
                  maxWidth: 500,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  {moduleList?.map((link, index) => (
                    <Box key={index} sx={{ width: "100%" }}>
                      <Box
                        sx={{
                          borderRadius: "4px",
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "6px",
                          alignItems: "center",
                          position: "relative",
                          height: "60px",
                          cursor: "pointer",
                        }}
                        onClick={(event) => {
                          event.stopPropagation();
                          handleToggleLessons(index, link.id);
                        }}
                      >
                        {/* Left Section */}
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: isShrunk ? "column" : "row",
                            alignItems: isShrunk ? "flex-start" : "center",
                            gap: "6px",
                            minWidth: "0",
                            overflow: "hidden",
                          }}
                        >
                          {/* Avatar */}
                          {!isShrunk && (
                            <Avatar
                              sx={{
                                fontWeight: "bold",
                                width: 36,
                                height: 36,
                                flexShrink: 0,
                                bgcolor: "primary.main",
                                color: "white",
                              }}
                            >
                              M
                            </Avatar>
                          )}

                          {/* Module Name */}
                          <Typography
                            variant="h5"
                            sx={{
                              fontWeight: 400,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              flexGrow: 1,
                            }}
                          >
                            {link.name}
                          </Typography>

                          {/* Duration & Progress */}
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "8px",
                              flexWrap: "nowrap",
                              whiteSpace: "nowrap",
                              flexShrink: 0,
                            }}
                          >
                            {expandedLinkIndex.includes(index) &&
                              getModuleProgress(moduleLessons, link.id) !==
                                null && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    flexGrow: 1,
                                    ml: 1,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      flexGrow: 1,
                                      minWidth: 80,
                                      display: !isShrunk
                                        ? { xs: "none", sm: "block" }
                                        : "none",
                                    }}
                                  >
                                    <LinearProgress
                                      variant="determinate"
                                      value={getModuleProgress(
                                        moduleLessons,
                                        link.id
                                      )}
                                      sx={{
                                        height: 6,
                                        borderRadius: 3,
                                      }}
                                    />
                                  </Box>

                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 400,
                                      minWidth: 30,
                                    }}
                                  >
                                    {getModuleProgress(moduleLessons, link.id)}%
                                  </Typography>
                                </Box>
                              )}

                            {/* Duration */}
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: 500,
                                padding: "0px 4px",
                              }}
                            >
                              {Math.floor(link.duration / 60) > 0
                                ? `${Math.floor(link.duration / 60)} hr${
                                    Math.floor(link.duration / 60) > 1
                                      ? "s"
                                      : ""
                                  } `
                                : ""}
                              {link.duration % 60 > 0
                                ? `${link.duration % 60} min${
                                    link.duration % 60 > 1 ? "s" : ""
                                  }`
                                : ""}
                            </Typography>
                          </Box>
                        </Box>

                        {/* Expand/Collapse IconButton (always visible and aligned) */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            paddingLeft: "8px",
                          }}
                        >
                          <IconButton
                            sx={{
                              padding: "4px",
                              alignSelf: "center",
                            }}
                          >
                            {expandedLinkIndex.includes(index) ? (
                              <ExpandLessIcon />
                            ) : (
                              <ExpandMoreIcon />
                            )}
                          </IconButton>
                        </Box>
                      </Box>

                      <Divider />
                      <Collapse
                        in={expandedLinkIndex.includes(index)}
                        timeout="auto"
                        unmountOnExit
                        sx={{
                          padding: "0 16px",
                          marginTop: "8px",
                          borderLeft: "4px solid",
                          borderLeftColor: "primary.main",
                        }}
                      >
                        {loadingModules[link.id] ? (
                          <LinearProgress
                            sx={{
                              width: "60%", // Set width to 60%
                              margin: "10px auto", // Center horizontally
                              display: "block", // Ensures it behaves like a block element
                            }}
                          />
                        ) : getFilteredLessons(link).length > 0 ? (
                          getFilteredLessons(link).map(
                            (lesson, lessonIndex) => {
                              if (!lessonRefs.current[link.id]) {
                                lessonRefs.current[link.id] = {};
                              }

                              const pathParts = location.pathname.split("/");
                              const moduleIdFromURL = parseInt(
                                pathParts[pathParts.indexOf("Module") + 1]
                              );
                              const lessonIdFromURL = parseInt(
                                pathParts[pathParts.indexOf("Lesson") + 1]
                              );

                              const isHighlighted =
                                moduleIdFromURL === link.id &&
                                lessonIdFromURL === lesson.id;
                              const isAssignmentContentType =
                                lesson.contentType === "assignment" ||
                                lesson.contentType === "writing";

                              return (
                                <React.Fragment key={lessonIndex}>
                                  <Box
                                    ref={(el) =>
                                      (lessonRefs.current[link.id][lesson.id] =
                                        el)
                                    }
                                    onClick={() => {
                                      // ❌ Disable click for students if lesson is locked
                                      if (
                                        !lesson.openForStudent &&
                                        AuthService.isStudent(courseId)
                                      )
                                        return;

                                      handleStartCourseOnLesson(
                                        lesson,
                                        link.id
                                      );
                                    }}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      position: "relative",
                                      width: "100%",
                                      padding: "6px 8px",
                                      backgroundColor: isHighlighted
                                        ? "#BBDEFB"
                                        : !lesson.openForStudent &&
                                          AuthService.isStudent(courseId)
                                        ? "#f5f5f5" // grey background for locked lessons
                                        : "transparent",
                                      borderRadius: "6px",
                                      cursor:
                                        !lesson.openForStudent &&
                                        AuthService.isStudent(courseId)
                                          ? "not-allowed"
                                          : "pointer",
                                      opacity:
                                        !lesson.openForStudent &&
                                        AuthService.isStudent(courseId)
                                          ? 0.5
                                          : 1,
                                      "&:hover": {
                                        backgroundColor:
                                          !lesson.openForStudent &&
                                          AuthService.isStudent(courseId)
                                            ? "#f5f5f5"
                                            : "#f0f0f0",
                                      },
                                    }}
                                  >
                                    {/* Left - Lesson Info */}
                                    <Box sx={{ flex: 1 }}>
                                      <Typography
                                        variant="h6"
                                        sx={{
                                          fontWeight: 650,
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <Tooltip
                                          title={
                                            lesson.contentType ===
                                            "formative_assessment"
                                              ? "Quiz"
                                              : isAssignmentContentType
                                              ? "Assignment"
                                              : "Read"
                                          }
                                          arrow
                                        >
                                          {lesson.contentType ===
                                          "formative_assessment" ? (
                                            <QuizIcon
                                              sx={{ cursor: "pointer" }}
                                            />
                                          ) : isAssignmentContentType ? (
                                            <AssignmentIcon
                                              sx={{ cursor: "pointer" }}
                                            />
                                          ) : (
                                            <AutoStoriesIcon
                                              sx={{ cursor: "pointer" }}
                                            />
                                          )}
                                        </Tooltip>

                                        {lesson.name}
                                        <Tooltip
                                          title={
                                            bookmarkedLessons.some(
                                              (item) =>
                                                item.moduleId === link.id &&
                                                item.lessonId === lesson.id
                                            )
                                              ? "Remove from favorites"
                                              : "Add to favorites"
                                          }
                                        >
                                          <IconButton
                                            size="small"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              toggleBookmark(
                                                link.id,
                                                lesson.id,
                                                lesson.chapterId,
                                                lesson.name
                                              );
                                            }}
                                          >
                                            {bookmarkedLessons.some(
                                              (item) =>
                                                item.moduleId === link.id &&
                                                item.lessonId === lesson.id
                                            ) ? (
                                              <BookmarksIcon
                                                sx={{ fontSize: 16 }}
                                                color="error"
                                              />
                                            ) : (
                                              <BookmarksIcon
                                                sx={{ fontSize: 16 }}
                                              />
                                            )}
                                          </IconButton>
                                        </Tooltip>
                                      </Typography>

                                      {/* Status */}
                                      {lesson.openForStudent ||
                                      AuthService.isFaculty(courseId) ? (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            alignItems: "center",
                                            gap: 1,
                                            mt: "4px",
                                          }}
                                        >
                                          {!isShrunk && (
                                            <Button
                                              size="small"
                                              variant="contained"
                                              sx={{
                                                padding: "4px 10px",
                                                lineHeight: 1,
                                                whiteSpace: "nowrap",
                                                minWidth: "auto",
                                                maxWidth: "100px",
                                              }}
                                              onClick={() =>
                                                handleStartCourseOnLesson(
                                                  lesson,
                                                  link.id
                                                )
                                              }
                                            >
                                              Open
                                            </Button>
                                          )}

                                          <Typography
                                            variant="caption"
                                            sx={{ fontWeight: 400, px: 1 }}
                                          >
                                            {lesson.duration} mins
                                          </Typography>

                                          {/* Grades & Dates */}
                                          {AuthService.isFaculty(courseId) ? (
                                            isAssignmentContentType ? (
                                              <Box sx={{ px: 1 }}>
                                                <Typography variant="caption">
                                                  Grading Status:{" "}
                                                </Typography>
                                                {facultyGrading?.[link.id]?.[
                                                  lesson.id
                                                ] ? (
                                                  <Typography variant="caption">
                                                    Graded:{" "}
                                                    {
                                                      facultyGrading[link.id][
                                                        lesson.id
                                                      ].gradedCount
                                                    }{" "}
                                                    | Pending:{" "}
                                                    {
                                                      facultyGrading[link.id][
                                                        lesson.id
                                                      ].pendingCount
                                                    }
                                                  </Typography>
                                                ) : (
                                                  <Typography
                                                    variant="caption"
                                                    sx={{ color: "gray" }}
                                                  >
                                                    No submissions yet
                                                  </Typography>
                                                )}
                                              </Box>
                                            ) : null
                                          ) : lesson.contentType ===
                                            "formative_assessment" ? (
                                            (() => {
                                              const gradeInfo = userGrades.find(
                                                (g) =>
                                                  String(g.lessonId) ===
                                                    String(lesson.id) &&
                                                  String(g.moduleId) ===
                                                    String(lesson.moduleId)
                                              );
                                              const grade =
                                                gradeInfo?.gradeObtained ?? 0;
                                              const dateCompleted =
                                                gradeInfo?.dateCompleted;

                                              return (
                                                <>
                                                  <Typography
                                                    variant="caption"
                                                    sx={{
                                                      fontWeight: 400,
                                                      px: 1,
                                                      color: !dateCompleted
                                                        ? "secondary.main"
                                                        : undefined,
                                                    }}
                                                  >
                                                    Grade: {grade}/
                                                    {lesson.grades}
                                                  </Typography>
                                                  <Typography
                                                    variant="caption"
                                                    sx={{
                                                      fontWeight: 400,
                                                      px: 1,
                                                      color: !dateCompleted
                                                        ? "secondary.main"
                                                        : undefined,
                                                    }}
                                                  >
                                                    {dateCompleted
                                                      ? new Date(
                                                          dateCompleted
                                                        ).toLocaleDateString(
                                                          "en-US"
                                                        )
                                                      : "Overdue"}
                                                  </Typography>
                                                </>
                                              );
                                            })()
                                          ) : isAssignmentContentType ? (
                                            (() => {
                                              const gradeInfo = userGrades.find(
                                                (g) =>
                                                  String(g.lessonId) ===
                                                    String(lesson.id) &&
                                                  String(g.moduleId) ===
                                                    String(lesson.moduleId)
                                              );
                                              const grade =
                                                gradeInfo?.gradeObtained ?? 0;
                                              const dateSubmitted =
                                                gradeInfo?.dateCompleted;
                                              const graded = gradeInfo?.graded;
                                              const completed =
                                                gradeInfo?.completed;

                                              if (completed) {
                                                return (
                                                  <>
                                                    <Typography
                                                      variant="caption"
                                                      sx={{ px: 1 }}
                                                    >
                                                      Grade: {grade}/
                                                      {lesson.grades}
                                                    </Typography>
                                                    <Typography
                                                      variant="caption"
                                                      sx={{ px: 1 }}
                                                    >
                                                      {dateSubmitted
                                                        ? new Date(
                                                            dateSubmitted
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : "No Date"}
                                                    </Typography>
                                                  </>
                                                );
                                              }

                                              return (
                                                <>
                                                  <Typography
                                                    variant="caption"
                                                    sx={{
                                                      px: 1,
                                                      color: "secondary.main",
                                                    }}
                                                  >
                                                    Grade: {grade}/
                                                    {lesson.grades}
                                                  </Typography>
                                                  <Typography
                                                    variant="caption"
                                                    sx={{
                                                      px: 1,
                                                      color: "secondary.main",
                                                    }}
                                                  >
                                                    {graded
                                                      ? "Resubmit"
                                                      : "Overdue"}
                                                  </Typography>
                                                </>
                                              );
                                            })()
                                          ) : lesson.dateCompleted ? (
                                            <Typography
                                              variant="caption"
                                              sx={{ px: 1 }}
                                            >
                                              Completed On:{" "}
                                              {new Date(
                                                lesson.dateCompleted
                                              ).toLocaleDateString("en-US")}
                                            </Typography>
                                          ) : null}
                                        </Box>
                                      ) : (
                                        <Typography
                                          variant="body2"
                                          sx={{ mt: "4px", fontWeight: 500 }}
                                        >
                                          Not Open
                                        </Typography>
                                      )}
                                    </Box>

                                    {/* Right - Progress */}
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-end",
                                        minWidth: "30px",
                                        flexShrink: 0,
                                        ml: 1,
                                        paddingRight: "4px",
                                      }}
                                    >
                                      <CircleProgressBar
                                        progress={
                                          typeof lessonProgress[link.id]?.[
                                            lesson.id
                                          ] === "number"
                                            ? lessonProgress[link.id][lesson.id]
                                            : lesson.dateCompleted
                                            ? 100
                                            : 0
                                        }
                                        size={15}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleProgressClick(
                                            lesson.id,
                                            link.id,
                                            lesson.chapterId,
                                            lesson.dateCompleted
                                          );
                                        }}
                                        disabled={AuthService.isStudent(
                                          courseId
                                        )}
                                      />
                                    </Box>
                                  </Box>

                                  {/* Divider */}
                                  <Divider
                                    sx={{
                                      borderStyle: "dashed",
                                      borderWidth: "1px",
                                      my: "4px",
                                    }}
                                  />
                                </React.Fragment>
                              );
                            }
                          )
                        ) : (
                          <Typography
                            sx={{
                              margin: "8px 0",
                            }}
                          >
                            No lessons available.
                          </Typography>
                        )}
                      </Collapse>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>
          )}
          {showExitModal && (
            <Dialog open onClose={() => setShowExitModal(false)}>
              <DialogTitle>Alert!!</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  You have unsaved changes. Are you sure you want to leave?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setShowExitModal(false)} color="primary">
                  Stay
                </Button>
                <Button
                  onClick={() => {
                    setShowExitModal(false);
                    localStorage.removeItem("assignmentUnsaved");
                    localStorage.removeItem("quizUnsaved");

                    if (pendingLessonNavigation) {
                      navigateToLesson(pendingLessonNavigation);
                      setPendingLessonNavigation(null);
                    } else {
                      navigate(`/Modules/Course/${courseId}`);
                    }
                  }}
                  color="error"
                >
                  Leave
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </Box>

        <Box
          sx={{
            flexGrow: 1, // ✅ Takes remaining space
            ml: isSidebarHidden ? 0 : sidebarWidth,
            overflow: "auto",
          }}
        >
          <Outlet
            context={{
              isShrunk,
              setIsShrunk,
              isSidebarHidden,
              setIsSidebarHidden,
              lessonProgress, // Pass the progress state
              setLessonProgress, // Pass the setter for updates
              handleProgressClick,
              //handleInActiveLessons,
              sidebarWidth,
              quizSubmissions,
              setManualSidebarToggle,
            }}
          />
        </Box>
      </Box>
    </Grid>
  );
};

export default MainPage;
